<div class="surface-card">
  <div class="surface-card-header surface-card-header-split">
    {{ 'uiModules.overview.configuration' | translate }}
    <sh-button
      *ngIf="!overviewConfiguration"
      label="shared.terms.add"
      icon="fa-regular fa-plus"
      variant="outlined"
      severity="secondary"
      size="sm"
      (click)="openDialog()"
    ></sh-button>
    <sh-button
      *ngIf="overviewConfiguration"
      label="shared.terms.edit"
      icon="fa-regular fa-pencil-alt"
      variant="outlined"
      severity="secondary"
      size="sm"
      (click)="openDialog()"
    ></sh-button>
  </div>

  <div *ngIf="!overviewConfiguration" class="surface-card-empty">
    {{ 'uiModules.overview.noConfiguration' | translate }}
  </div>

  <div *ngIf="overviewConfiguration" class="surface-card-body">
    <div class="form-grid">
      <sh-field label="uiModules.pageSize" [readonly]="true">
        <sh-input [value]="overviewConfiguration.pageSize"></sh-input>
      </sh-field>
      <sh-field label="uiModules.sortFieldCode" [readonly]="true">
        <sh-input [value]="overviewConfiguration.sortFieldCode"></sh-input>
      </sh-field>
      <sh-field label="uiModules.sorting" [readonly]="true">
        <sh-input
          [value]="
            (isSortAscending ? 'shared.terms.asc' : 'shared.terms.desc')
              | translate
          "
        ></sh-input>
      </sh-field>
      <sh-field
        class="field-wide"
        label="uiModules.displayColumns"
        [readonly]="true"
      >
        <sh-input
          [value]="overviewConfiguration.displayColumnsCodes"
        ></sh-input>
      </sh-field>
    </div>
  </div>

  <ng-container *ngIf="overviewConfiguration && displayFieldRows.length">
    <div class="surface-card-header">
      {{ 'seahorseModules.displayFieldsConfiguration' | translate }}
    </div>
    <sh-table
      tableId="seahorse-module-display-fields"
      density="compact"
      dataKey="field"
      [columns]="columns"
      [rows]="displayFieldRows"
    ></sh-table>
  </ng-container>
</div>
